/* eslint-disable no-console */

import React from 'react';
import { Row, Col } from 'react-grid-system';
import { getLocalizedText as text } from '@vp-dst/localization-util';

import DesignServicesUtil from 'utils/DesignServicesUtil';
import NavigationUtil from 'utils/NavigationUtil';

import DSHubModel from 'models/DSHubModel';

import Service from 'components/Service';
import ServiceTileHorizontal from 'components/ServiceTileHorizontal';
import withScreenClass, { withScreenClassPropTypes } from 'components/highOrder/withScreenClass';

import logoDesignIconSrc from 'images/icons/logo-design.svg';
import productDesignIconSrc from 'images/icons/product-design.svg';
import websiteDesignIconSrc from 'images/icons/website-design.svg';
import logoMakerIconSrc from 'images/icons/logo-maker-icon.svg';
import socialMediaIconSrc from 'images/icons/social-media-icon.svg';
import designLiveIconSrc from 'images/icons/design-live.svg';

function Services(props) {
  const {
    screenClass,
  } = props;

  const extraSmallScreen = screenClass === 'xs';

  return (
    <div
      style={{
        marginBottom: extraSmallScreen ? 55 : 50,
      }}
    >
      <Row>
        <Col sm={12}>
          {DSHubModel.showSocialMediaDesign
            && (
              <ServiceTileHorizontal
                iconSrc={socialMediaIconSrc}
                title={text('digital-social-media-design')}
                caption={text('designs-for-online-presence')}
                highlight={text('get-equipped-to-promote-yourself-online')}
                hideWeCanText
                iconOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getSocialMediaBriefURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'SocialMediaIcon',
                  },
                })}
                buttonOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getSocialMediaBriefURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'SocialMediaCTA',
                  },
                })}
                buttonLinkHref={NavigationUtil.addXNav(DesignServicesUtil.getSocialMediaBriefURL(), 'ServiceTiles', 'SocialMediaLink')}
              />
            )
          }
        </Col>
      </Row>
      {DSHubModel.showLogoDesignService
        && (
          <Row>
            <Col sm={DSHubModel.isCoDesignEnabled ? 4 : 6}>
              <Service
                iconSrc={logoDesignIconSrc}
                hideWeCanText
                title={text('logo-design')}
                caption={text('receive-within-2-business-days')}
                priceHTML={DSHubModel.logoDesignServicePriceHTML}
                highlights={[
                  text('get-a-custom-made-business-logo'),
                  text('choose-from-3-unique-options'),
                  text('logo-refine-with-up-to-3-rounds-of-revisions'),
                ]}
                iconOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getLogoDesignBriefURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'LogoIcon',
                  },
                })}
                buttonOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getLogoDesignBriefURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'LogoGetStartedCTA',
                  },
                })}
                buttonLinkHref={NavigationUtil.addXNav(DesignServicesUtil.getLogoDesignBriefURL(), 'ServiceTiles', 'LogoGetStartedLink')}
              />
            </Col>
            <Col sm={DSHubModel.isCoDesignEnabled ? 4 : 6}>
              <Service
                iconSrc={productDesignIconSrc}
                hideWeCanText
                title={text('printed-product-design')}
                caption={text('receive-within-24-hours')}
                priceHTML={DSHubModel.productDesignServicePriceHTML}
                highlights={[
                  text('request-custom-designs-edits-or-updates'),
                  text('Work-with-a-designer-via-our-online-dashboard'),
                  text('refine-with-up-to-3-rounds-of-revisions'),
                ]}
                iconOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getProductDesignBriefURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'ProductDesignIcon',
                  },
                })}
                buttonOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getProductDesignBriefURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'ProductDesignGetStartedCTA',
                  },
                })}
                buttonLinkHref={NavigationUtil.addXNav(DesignServicesUtil.getProductDesignBriefURL(), 'ServiceTiles', 'ProductDesignGetStartedLink')}
              />
            </Col>
            <Col sm={4}>
              {DSHubModel.isCoDesignEnabled
                && (
                  <Service
                    showNewCallout
                    iconSrc={designLiveIconSrc}
                    title={text('design-live')}
                    caption={text('by-appointment')}
                    priceHTML={DSHubModel.designLiveServicePriceHTML}
                    hideWeCanText
                    highlights={[
                      text('video-conference-with-a-design-pro'),
                      text('request-custom-designs-edits-or-updates'),
                      text('review-and-refine-options-in-real-time'),
                    ]}
                    iconOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getProductDesignBriefURL({ designLivePreSelected: true }), {
                      xNav: {
                        pageZone: 'ServiceTiles',
                        details: 'DesignLiveIcon',
                      },
                    })}
                    buttonOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getProductDesignBriefURL({ designLivePreSelected: true }), {
                      xNav: {
                        pageZone: 'ServiceTiles',
                        details: 'DesignLiveGetStartedCTA',
                      },
                    })}
                    buttonLinkHref={
                      NavigationUtil.addXNav(DesignServicesUtil.getProductDesignBriefURL({ designLivePreSelected: true }),
                        'ServiceTiles',
                        'DesignLiveGetStartedLink')
                    }
                  />
                )
              }
            </Col>
          </Row>
        )
      }
      {!DSHubModel.showLogoDesignService
        && (
          <Row>
            <Col sm={DSHubModel.isCoDesignEnabled ? 6 : 8} offset={{ sm: DSHubModel.isCoDesignEnabled ? 0 : 2 }}>
              <Service
                iconSrc={productDesignIconSrc}
                title={text('printed-product-design')}
                caption={text('receive-within-24-hours')}
                priceHTML={DSHubModel.productDesignServicePriceHTML}
                hideWeCanText
                highlights={[
                  text('request-custom-designs-edits-or-updates'),
                  text('Work-with-a-designer-via-our-online-dashboard'),
                  text('refine-with-up-to-3-rounds-of-revisions'),
                ]}
                iconOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getProductDesignBriefURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'ProductDesignIcon',
                  },
                })}
                buttonOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getProductDesignBriefURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'ProductDesignGetStartedCTA',
                  },
                })}
                buttonLinkHref={NavigationUtil.addXNav(DesignServicesUtil.getProductDesignBriefURL(), 'ServiceTiles', 'ProductDesignGetStartedLink')}
              />
            </Col>
            <Col sm={6}>
              {DSHubModel.isCoDesignEnabled
                && (
                  <Service
                    showNewCallout
                    iconSrc={designLiveIconSrc}
                    title={text('design-live')}
                    caption={text('by-appointment')}
                    priceHTML={DSHubModel.designLiveServicePriceHTML}
                    hideWeCanText
                    highlights={[
                      text('video-conference-with-a-design-pro'),
                      text('request-custom-designs-edits-or-updates'),
                      text('review-and-refine-options-in-real-time'),
                    ]}
                    iconOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getProductDesignBriefURL({ designLivePreSelected: true }), {
                      xNav: {
                        pageZone: 'ServiceTiles',
                        details: 'DesignLiveIcon',
                      },
                    })}
                    buttonOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getProductDesignBriefURL({ designLivePreSelected: true }), {
                      xNav: {
                        pageZone: 'ServiceTiles',
                        details: 'DesignLiveGetStartedCTA',
                      },
                    })}
                    buttonLinkHref={NavigationUtil.addXNav(DesignServicesUtil.getProductDesignBriefURL({ designLivePreSelected: true }),
                      'ServiceTiles', 'DesignLiveGetStartedLink')}
                  />
                )
              }
            </Col>
          </Row>
        )
      }
      <Row>
        <Col sm={12}>
          {DSHubModel.showLogoMakerService
            && (
              <ServiceTileHorizontal
                iconSrc={logoMakerIconSrc}
                title={text('diy-logo-maker')}
                caption={text('free-to-use-on-vistaprint-products')}
                highlight={text('find-your-favorite-customizable-logo')}
                hideWeCanText
                iconOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getLogoMakerURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'LogomakerIcon',
                  },
                })}
                buttonOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getLogoMakerURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'LogoMakerCTA',
                  },
                })}
                buttonLinkHref={NavigationUtil.addXNav(DesignServicesUtil.getLogoMakerURL(), 'ServiceTiles', 'LogoMakerLink')}
              />
            )
          }
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          {DSHubModel.showWebsiteDesignService
            && (
              <ServiceTileHorizontal
                iconSrc={websiteDesignIconSrc}
                title={text('website-design')}
                caption={text('free-creation-paid-subscription')}
                buttonTextOverride={text('learn-more')}
                highlight={text('team-up-with-a-designer-to-create')}
                hideWeCanText
                iconOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getDifyWebsitesURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'WebsiteIcon',
                  },
                })}
                buttonOnClick={() => NavigationUtil.navigateTo(DesignServicesUtil.getDifyWebsitesURL(), {
                  xNav: {
                    pageZone: 'ServiceTiles',
                    details: 'WebsiteDesignLearnMoreCTA',
                  },
                })}
                buttonLinkHref={NavigationUtil.addXNav(DesignServicesUtil.getDifyWebsitesURL(), 'ServiceTiles', 'WebsiteDesignLearnMoreLink')}
              />
            )
          }
        </Col>
      </Row>
    </div>
  );
}

Services.propTypes = {
  ...withScreenClassPropTypes,
};

export default withScreenClass(Services);



// WEBPACK FOOTER //
// ./src/components/Services.js